var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, } from "@mui/material";
import clsx from "clsx";
import { useMemo, useRef } from "react";
import { UiTypography } from "../ui_typography";
import { useStyles } from "./ui_select.css";
export const UiSelect = (_a) => {
    var { autoWidth, className, disabled, errorMessage, fullWidth, gutterBottom, isLoading, isSmall, isSortDisabled, label, options, sortFunction } = _a, props = __rest(_a, ["autoWidth", "className", "disabled", "errorMessage", "fullWidth", "gutterBottom", "isLoading", "isSmall", "isSortDisabled", "label", "options", "sortFunction"]);
    const selectRef = useRef(null);
    const classes = useStyles({ gutterBottom });
    const sortedOptions = useMemo(() => isSortDisabled
        ? options
        : [...options].sort(sortFunction
            ? sortFunction
            : ({ label: label1 }, { label: label2 }) => !label1 || !label2 || label1 === label2
                ? 0
                : label1 > label2
                    ? 1
                    : -1), [isSortDisabled, options, sortFunction]);
    return useMemo(() => {
        var _a, _b, _c;
        return (_jsxs("div", { className: clsx(classes.ui_select, className), children: [_jsxs(FormControl, { fullWidth: fullWidth, variant: "outlined", size: isSmall ? "small" : undefined, children: [label && _jsx(InputLabel, { children: label }), _jsx(Select, Object.assign({ disabled: isLoading || disabled, input: _jsx(OutlinedInput, { label: label }), ref: selectRef, IconComponent: isLoading
                                ? () => (_jsx(CircularProgress, { className: classes.spinner, color: "inherit", size: 20 }))
                                : undefined }, props, { MenuProps: Object.assign({ disablePortal: true, PaperProps: Object.assign({ style: Object.assign({ width: autoWidth ? undefined : 100 }, (_b = (_a = props.MenuProps) === null || _a === void 0 ? void 0 : _a.PaperProps) === null || _b === void 0 ? void 0 : _b.style) }, (_c = props.MenuProps) === null || _c === void 0 ? void 0 : _c.PaperProps) }, props.MenuProps), children: sortedOptions.map(({ disabled, label, value }, idx) => (_jsx(MenuItem, { disabled: disabled, value: value, children: _jsxs(UiTypography, { noWrap: true, style: {
                                        lineHeight: 1.5,
                                    }, children: [" ", label] }) }, typeof label === "string" ? label : idx))) }))] }), errorMessage && _jsx(FormHelperText, { children: errorMessage })] }));
    }, [
        classes.ui_select,
        classes.spinner,
        className,
        fullWidth,
        isSmall,
        label,
        isLoading,
        disabled,
        props,
        autoWidth,
        sortedOptions,
        errorMessage,
    ]);
};
//# sourceMappingURL=ui_select.js.map